/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { Controller, useController, type Control, type ControllerProps, type FieldError, type FieldValues } from 'react-hook-form';
import { FormControl, FormHelperText, TextField, type TextFieldProps } from '@mui/material';
import React from 'react';
import { useTranslation } from '../../Translation/translationProvider';

export type CustomTextFieldProps<T extends FieldValues = FieldValues> = Omit<TextFieldProps,
  'name'> & {
    validation?: ControllerProps['rules']
    name: string
    parseError?: (error: FieldError) => string
    control?: Control<any, any>
    label?: string
    maxLength?:number
  }

const CustomTextField: React.FC<CustomTextFieldProps> = ({ validation = {},
    parseError,
    type,
    required,
    name,
    control,
    helperText,
    fullWidth,
    sx,
    label,
    maxLength,
    ...rest }) => {
        const { t } = useTranslation();
        let {  } = useController({
    name: name,
    // rules: attributeInputCallback.isRequired() ? { required: 'This field is required' } : undefined,
    control: control
  })

  if (required) {
    validation.required = t(`common.fieldRequired`)
  }


    return (
        <Controller
      name={name}
      control={control}
      rules={validation}
      render={({ field: { value, onChange }, fieldState: { error } }) =>
          <FormControl  id={name+'_formControl'} error={!!error} fullWidth>
            <TextField className="customTextField"
            value={value}
            name={name}
            onChange={(value)=>{
                onChange(value)
            }}
            label={label}
            error={!!error}
            required={required}
            type={type}
            helperText={!!maxLength ? `${value?.length ? value?.length : 0}/${maxLength}` : undefined}
            slotProps={{ inputLabel: { shrink: value || undefined } }} 
            {...rest}
            />
            {!!error && <FormHelperText className="formHelperClass">{error?.message}</FormHelperText>}
          </FormControl>
        // </div>
      }
    />
    );
}

export default React.memo(CustomTextField);